// extracted by mini-css-extract-plugin
export default {"subtitleHighlight":"Learners_subtitleHighlight__ktx2x","article":"Learners_article__oGRnn","contactInfo":"Learners_contactInfo__FtwsY","articles":"Learners_articles__hu89Y"};